import { fetchEmployeeSharedPercentage } from '../../api/dues.api';

export default {
    async createFormDataForThirdStepFromResponse(response) {
        let formData = {
            contributions: await this.processResponseContributions(response.contributions, response.collectiveAgreement)
        };

        if (null !== response.isEligiblePartiesCanJoin) {
            formData.isEligiblePartiesCanJoin = response.isEligiblePartiesCanJoin;
        }

        if (response.eligiblePartiesJoinType) {
            formData.eligiblePartiesJoinType = response.eligiblePartiesJoinType;
        }

        if (response.contributionOption) {
            formData.contributionOptionId = response.contributionOption.id;
        }

        if (null !== response.isContributionChargedFromSalary) {
            formData.isContributionChargedFromSalary = response.isContributionChargedFromSalary;
        }

        if (response.contributionChargedDaysAfterDebitDate) {
            formData.contributionChargedDaysAfterDebitDate = response.contributionChargedDaysAfterDebitDate;
        }

        if (null !== response.isAdditionalGuarantiesMandatory) {
            formData.isAdditionalGuarantiesMandatory = response.isAdditionalGuarantiesMandatory;
        }

        if (null !== formData.otherAffiliatesContribution) {
            formData.otherAffiliatesContribution = response.otherAffiliatesContribution;
        }

        return formData;
    },
    async createThirdStepUpdateRequest(formData) {
        let request = {
            contributions: await this.processContributions(formData.contributions),
            propertiesToNull: [],
            contributionOptionId: formData.contributionOptionId
        };

        if (null !== formData.isEligiblePartiesCanJoin) {
            request.isEligiblePartiesCanJoin = formData.isEligiblePartiesCanJoin;
        }

        if (formData.eligiblePartiesJoinType) {
            request.eligiblePartiesJoinType = formData.eligiblePartiesJoinType;
        }

        if (null !== formData.isContributionChargedFromSalary) {
            request.isContributionChargedFromSalary = formData.isContributionChargedFromSalary;
        }

        if (formData.contributionChargedDaysAfterDebitDate) {
            request.contributionChargedDaysAfterDebitDate = formData.contributionChargedDaysAfterDebitDate;
        }
        
        if (null !== formData.isAdditionalGuarantiesMandatory) {
            request.isAdditionalGuarantiesMandatory = formData.isAdditionalGuarantiesMandatory;
        }

        if (null !== formData.otherAffiliatesContribution) {
            request.otherAffiliatesContribution = formData.otherAffiliatesContribution;
        }

        return request;
    },
    async processContributions(contributions) {
        let result = [];
        for (const contribution of contributions) {
            result.push({
                contributionOptionUnitId: contribution.contributionOptionUnit.id,
                employerSharePercentage: contribution.employerSharePercentage,
                employeeSharePercentage: contribution.employeeSharePercentage
            });
        }

        return result;
    },
    async processResponseContributions(contributions, collectiveAgreement) {
        let result = [];
        for (const contribution of contributions) {
            const { data } = await fetchEmployeeSharedPercentage(
                contribution.contributionOptionUnit.id,
                collectiveAgreement.id
            );
            result.push({
                ...contribution,
                contributionMinimumPercentage: data
            });
        }

        return result;
    }
};